import React from 'react';

const noop = () => {};

const context = /*#__PURE__*/React.createContext({
  show: noop,
  hide: noop
});
export const useTooltip = () => React.useContext(context);
export const {
  Provider,
  Consumer
} = context;